<template>
    <div class="page-btn">
      <span class="label">Lagre på side</span>
      <template v-if="spread">
        <button v-if="evenPage" :title="`Lagre på side ${$store.getters.evenPage.pageNumber}`" @click.prevent="add($store.getters.evenPage.pageNumber)" name="evenPage"><t-icon name="icon-page-left" /></button>
        <button v-if="oddPage" :title="`Lagre på side ${$store.getters.oddPage.pageNumber}`" @click.prevent="add($store.getters.oddPage.pageNumber)" name="oddPage"><t-icon name="icon-page-right" /></button>
      </template>
      <template v-else>
        <button name="currentPage" :title="`Lagre på side ${$store.getters.currentPage.pageNumber}`" @click.prevent="add($store.getters.currentPage.pageNumber)"><t-icon name="icon-page-right" /></button>
      </template>
    </div>
</template>

<script>
export default {
  // See MenuItem.vue's comment for why this is required in Vue 3.
  emits: ['click'],
  methods: {
    add (pageNumber) {
      this.$emit('click', pageNumber)
    }
  },
  computed: {
    spread () {
      return this.$store.getters.spread
    },
    evenPage () {
      return this.$store.getters.evenPage
    },
    oddPage () {
      return this.$store.getters.oddPage
    }
  }
}
</script>

<style>

</style>
